import React from "react";
import PayFromBalanceReq from "../../Classes/Models/Requests/Accounting/PayFromBalanceReq";
import AccountingApi from "../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import { useContext } from "react";
import { UserContext } from "App";
const PayFromBalanceButton = ({ Session, setIsLoaded }) => {
  let CurrentUser = useContext(UserContext);

  const PayFromBalance = async (PaymentType) => {
    Swal.fire({
      title: "Please Wait",
      text: "Processing your request",
      icon: "info",
      showConfirmButton: false,
    });

    if (PaymentType == "AccountingSession") {
      let req = new PayFromBalanceReq();

      req.paymentType = "AccountingSession";
      req.accountingSessionId = Session.id;
      req.userId = Session.getPatient.getUser.id;

      var res = await AccountingApi.PayFromBalance(req);

      if (res.status == "Success") {
        Swal.fire("Success", res.message, "success").then(() => {
          if (setIsLoaded) {
            setIsLoaded(false);
          } else {
            window.location.reload();
          }
        });
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    } else if (PaymentType == "PackageSession") {
      let req = new PayFromBalanceReq();

      req.paymentType = "PackageSession";
      req.accountingSessionId = Session.id;
      req.userId = CurrentUser.id;
      req.packageId = Session.packageId;

      var res = await AccountingApi.PayFromBalance(req);

      if (res.status == "Success") {
        Swal.fire("Success", res.message, "success").then(() => {
          if (setIsLoaded) {
            setIsLoaded(false);
          } else {
            window.location.reload();
          }
        });
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    }
  };
  if (Session.isPaidFor) {
    return (
      <button className="btn btn-success m-3" disabled={true}>
        Session Paid
      </button>
    );
  }
  if (
    Session.packageId == undefined &&
    Session.domesticStayId == undefined &&
    Session.domesticStayExtraId == undefined
  ) {
    if (
      Session.getPatient.getUser.getLastBalanceEntry &&
      Session.getPatient.getUser.getLastBalanceEntry.currentBalance < Session.finalPrice
    ) {
      return (
        <button className="btn btn-danger m-3" disabled={true}>
          Insufficient Funds
        </button>
      );
    } else if (!Session.getPatient.getUser.getLastBalanceEntry) {
      return (
        <button className="btn btn-dark m-3" disabled={true}>
          NO BALANCE DETECTED
        </button>
      );
    } else {
      return (
        <button
          onClick={() => PayFromBalance("AccountingSession")}
          className="btn btn-success m-3"
          disabled={Session.isPaidFor}
        >
          Pay with balance
        </button>
      );
    }
  } else if (Session.domesticStayId != null || Session.domesticStayExtraId) {
    return (
      <button className="btn btn-danger m-3" disabled={true}>
        In Patient Stay Disabled
      </button>
    );
  }
  // else if (Session.packageId != null && Object.keys(Package).length > 0) {
  else if (Session.packageId != null) {
    return (
      <button onClick={() => PayFromBalance("PackageSession")} className="btn btn-success">
        ${Session.finalPrice}
      </button>
    );
  }
};

export default PayFromBalanceButton;
